// extracted by mini-css-extract-plugin
module.exports =  {"placeholder":"InjectHtml__placeholder--ZT","inline":"InjectHtml__inline--Bk"};